import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MonthlyDSABusinessCard from "../MonthlyBusiness/monthlyDsaBusiness";
export default function MonthlyDSABusiness() {
  return (
    <DashboardLayout>
      <MonthlyDSABusinessCard />
    </DashboardLayout>
  );
}
